import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, SelfBookingAppointmentCoachAvailableTimeSlot, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

interface IUseSelfBookingAvailableSlots {
  appointmentTypeId?: string;
  staffId: string;
  startDate: string;
  enabled?: boolean;
}

export default function useSelfBookingAppointmentAvailableSlots({
  appointmentTypeId,
  staffId,
  startDate,
  enabled = true,
}: IUseSelfBookingAvailableSlots): UseQueryResult<
  AxiosResponse<SelfBookingAppointmentCoachAvailableTimeSlot[]>,
  AxiosError<ErrorMessage>
> {
  const queryFn = (): Promise<AxiosResponse<SelfBookingAppointmentCoachAvailableTimeSlot[]>> => {
    const params: UrlParams = {};

    if (staffId) {
      params.staff_id = staffId;
    }
    if (startDate) {
      params.start_date = startDate;
    }

    return client.get(`appointment-self-booking/${appointmentTypeId}/available-slots/`, {
      params,
    });
  };

  return useQuery(
    ['appointment-type-self-booking-available-slots', appointmentTypeId, staffId, startDate, enabled],
    queryFn,
    {
      enabled: enabled && !!appointmentTypeId && !!staffId && !!startDate,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
  );
}
